/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
import { CustomHeader, Screen, Text } from "components"
import React, { useCallback, useState, useEffect } from "react"
import {
  ActivityIndicator,
  FlatList,
  Image,
  Platform,
  TouchableOpacity,
  View,
  useWindowDimensions,
} from "react-native"
import { style } from "./styles"
import { useFocusEffect, useNavigation } from "@react-navigation/native"
import { TabView } from "react-native-tab-view"
import { translate } from "i18n"
import LinearGradient from "react-native-linear-gradient"
import { colors } from "colors"
import { useSessionExpired } from "utils/function"
import flash from "config/flash"
import { useStores } from "models"
import moment from "moment"
import useResponsiveWidth from "components/fitSize"
import expired from "../../../../assets/expired.png"
import claimed from "../../../../assets/claimed-img.png"
import countdown from "../../../../assets/countdown.gif"
import emptyIcon from "../../../../assets/empty-icon.png"

import { useColor } from "app/theme/getThemes"

export const VoucherScreen = () => {
  const navigation = useNavigation<any>()
  const { companyTheme } = useColor()

  // const { width } = useWindowDimensions()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const { userStore } = useStores()
  const { sessionExpired } = useSessionExpired()
  const [voucher, setVoucher] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [voucherHistory, setVoucherHistory] = useState([])

  const [index, setIndex] = useState(0)
  const [routes] = useState([
    { key: "first", title: "Ongoing rewards" },
    { key: "second", title: "Rewards History" },
  ])

  useFocusEffect(
    useCallback(() => {
      getMemberVoucher()
      getMemberVoucherHistory()
    }, []),
  )

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     getMemberVoucher() // This will keep checking every 1 minute
  //   }, 60000) // 1 minute interval

  //   return () => clearInterval(interval) // Clear interval when component unmounts
  // }, [])

  const getMemberVoucher = async () => {
    setIsLoading(true)

    await fetch(`${process.env.API_URL}/api/voucher_list/member/${userStore?.id}/ongoing`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        setIsLoading(false)

        if (res?.ok) {
          const responseData = await res?.json()

          // Filter out vouchers that are not 'deleted'
          const filteredVouchers = responseData.filter((a) => a.status !== "deleted")

          const shouldRefresh = filteredVouchers.some((voucher) => {
            const useAtTime = new Date(voucher.use_at).getTime() // Convert 'use_at' to timestamp
            const currentTime = new Date().getTime() // Current time in milliseconds

            const timeDifference = (useAtTime - currentTime) / (1000 * 60) // Difference in minutes

            // console.log(timeDifference)

            return timeDifference < 2 && timeDifference > 0 // Less than 15 minutes and not in the past
          })

          console.log("example ongoing", filteredVouchers)

          console.log("shouldRefresh", shouldRefresh)

          if (shouldRefresh) {
            setVoucher(filteredVouchers)
            console.log("Use at meet criteria")
            // refreshList()
          } else {
            setVoucher(filteredVouchers)
          }
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetrieveVoucher"))
          }
        }
      })
      .catch((e) => {
        setIsLoading(false)
        flash("error", translate("errors.failedToRetrieveVoucher"))
        console.error(e)
      })
  }

  const getMemberVoucherHistory = async () => {
    setIsLoading(true)
    await fetch(`${process.env.API_URL}/api/voucher_list/member/${userStore?.id}/used`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        setIsLoading(false)
        if (res?.ok) {
          const responseData = await res?.json()

          // console.log(responseData)

          setVoucherHistory(responseData.filter((a: any) => a.status !== "deleted"))
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          } else {
            flash("error", translate("errors.failedToRetreiveVoucher"))
          }
        }
      })
      .catch((e) => {
        setIsLoading(false)
        flash("error", translate("errors.failedToRetreiveVoucher"))
        console.error(e)
      })
  }

  // const refreshList = () => {
  //   getMemberVoucher()
  //   getMemberVoucherHistory()
  // }

  const FirstRoute = () => <Content data={voucher} type="ongoing" />

  const SecondRoute = () => <Content data={voucherHistory} type="history" />

  const Content = (props) => {
    const { data, type } = props
    const isHistory = type === "history"
    return (
      <FlatList
        contentContainerStyle={style.flatListContainer}
        data={data}
        showsVerticalScrollIndicator={false}
        ListEmptyComponent={() => {
          return (
            <View style={style.emptyContainer}>
              {isLoading ? (
                <ActivityIndicator size="large" color={companyTheme.first} />
              ) : (
                <>
                  <Image
                    source={emptyIcon}
                    style={{ width: 100, height: 100, resizeMode: "contain" }}
                  />
                  <Text style={style.emptyTitle}>{translate("voucherScreen.noVoucher")}</Text>
                </>
              )}
            </View>
          )
        }}
        // ListFooterComponent={() => {
        //   return (
        //     <>
        //       {!isHistory && (
        //         <View style={{ alignItems: "center", marginTop: 20 }}>
        //           <Text style={style.voucherDescription}>
        //             {translate("voucherScreen.cannotFindVoucher")}
        //           </Text>
        //           <Text style={style.voucherDescription}>
        //             {translate("voucherScreen.try")}{" "}
        //             <Text
        //               onPress={() => navigation.push("voucher", { routeFrom: "history" })}
        //               style={{ color: companyTheme.first }}
        //             >
        //               {translate("voucherScreen.searchHistory")}
        //             </Text>
        //           </Text>
        //         </View>
        //       )}
        //     </>
        //   )
        // }}
        renderItem={({ item }) => {
          const voucherName = item?.voucher_name?.split(" ").slice(0, 3).join(" ") + "..."

          return (
            <TouchableOpacity
              onPress={() => {
                navigation.navigate("voucherDetail", {
                  item,
                  routeFrom: isHistory ? "voucherHistory" : "myVoucher",
                })
              }}
              style={style.voucherContainer}
            >
              <View style={style.row}>
                {isHistory ? (
                  <>
                    <Image
                      source={{
                        uri: item?.voucher_image,
                      }}
                      resizeMode="cover"
                      style={[style.image, { tintColor: "gray" }]}
                    />
                    <Image
                      source={{
                        uri: item?.voucher_image,
                      }}
                      resizeMode="cover"
                      style={[style.image, { opacity: 0.3, position: "absolute" }]}
                    />
                  </>
                ) : (
                  <Image
                    source={{
                      uri: item?.voucher_image,
                    }}
                    resizeMode="cover"
                    style={style.image}
                  />
                )}
                <View style={{ display: "flex", flexDirection: "row", width: "80%" }}>
                  <View style={{ display: "flex", flexDirection: "column", width: "80%" }}>
                    <Text style={[style.text, isHistory && { color: colors.darkerGrey }]}>
                      {voucherName}
                    </Text>

                    {isHistory ? (
                      <Text style={[style.expiryText, { color: colors.darkerGrey }]}>
                        {item?.use_at
                          ? translate("voucherScreen.usedOn")
                          : translate("voucherScreen.expiredOn")}{" "}
                        {moment(item?.use_at ? item?.use_at : item?.voucher_expire_at).format(
                          "DD-MM-YYYY",
                        )}
                      </Text>
                    ) : (
                      <Text style={[style.expiryText, isHistory && { color: colors.darkerGrey }]}>
                        {translate("voucherScreen.expiry")}:{" "}
                        {moment(item?.voucher_expire_at).format("DD-MM-YYYY")}
                      </Text>
                    )}
                  </View>
                  <View style={{ width: "20%", alignItems: "center", justifyContent: "center" }}>
                    {!isHistory && moment(item?.use_at).isBefore(moment().add(15, "minutes")) && (
                      <Image
                        source={require("../../../../assets/countdown.gif")}
                        resizeMode="contain"
                        style={{
                          width: 40,
                          height: 40,
                          zIndex: 999,
                        }}
                      />
                    )}
                  </View>
                </View>
              </View>
              <View style={style.dividerView}>
                <View style={style.dividerViewStyle} />
              </View>

              <Text style={style.voucherDescription} numberOfLines={1}>
                {item?.voucher_description.replace(/<[^>]*>/gim, "")}
              </Text>

              {isHistory ? (
                item?.use_at ? (
                  <Image
                    source={claimed}
                    resizeMode="cover"
                    style={{
                      width: 80,
                      height: 80,
                      position: "absolute",
                      right: 10,
                      bottom: 20,
                      zIndex: 999,
                      opacity: 0.8,
                    }}
                  />
                ) : (
                  <Image
                    source={expired}
                    resizeMode="cover"
                    style={{
                      width: 80,
                      height: 80,
                      position: "absolute",
                      right: 10,
                      bottom: 20,
                      zIndex: 999,
                      opacity: 0.8,
                    }}
                  />
                )
              ) : null}
            </TouchableOpacity>
          )
        }}
      />
    )
  }

  return (
    <>
      <CustomHeader headerTitle={translate("voucherScreen.title")} />

      <Screen>
        <View style={style.container}>
          <TabView
            swipeEnabled={false}
            animationEnabled={false}
            lazy
            renderTabBar={(props) => (
              <LinearGradient
                style={[style.linearGradient, { height: 60 }]}
                colors={[companyTheme.first, companyTheme.second]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 0 }}
              >
                <View style={style.headerTabBarContainer}>
                  {props.navigationState.routes.map((route, i) => {
                    return (
                      <TouchableOpacity
                        key={i}
                        onPress={() => setIndex(i)}
                        style={[style.tabBar, index === i && style.selectedTabBar]}
                      >
                        <Text
                          style={
                            index === i
                              ? {
                                  color: companyTheme.first,
                                  fontWeight: "bold",
                                  textAlign: `center${Platform.OS === "web" ? " !important" : ""}`,
                                }
                              : {
                                  color: colors.white,
                                  textAlign: `center${Platform.OS === "web" ? " !important" : ""}`,
                                }
                          }
                        >
                          {route.title}
                        </Text>
                      </TouchableOpacity>
                    )
                  })}
                </View>
              </LinearGradient>
            )}
            navigationState={{ index, routes }}
            renderScene={({ route }) => {
              switch (route.key) {
                case "first":
                  return FirstRoute()
                default:
                  return SecondRoute()
              }
            }}
            onIndexChange={setIndex}
            initialLayout={{ width }}
          />
        </View>
      </Screen>
    </>
  )
}
